import { render, staticRenderFns } from "./ReviewProposal.vue?vue&type=template&id=f5aa8bb8&scoped=true&"
import script from "./ReviewProposal.vue?vue&type=script&lang=js&"
export * from "./ReviewProposal.vue?vue&type=script&lang=js&"
import style0 from "./ReviewProposal.vue?vue&type=style&index=0&id=f5aa8bb8&prod&scoped=true&lang=css&"
import style1 from "./ReviewProposal.vue?vue&type=style&index=1&id=f5aa8bb8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5aa8bb8",
  null
  
)

export default component.exports